export const LOAD_COURSE_DETAILS_PAGE_DATA = 'LOAD_COURSE_DETAILS_PAGE_DATA'

export function loadCoursePageData({ courseSlug, req }) {
  return {
    type: LOAD_COURSE_DETAILS_PAGE_DATA,
    payload: { courseSlug, req },
  }
}
